import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const PERMITS_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/permits-management`;

/**
 * Hook to fetch all permits for dropdown selection
 */
export const usePermitsList = (options = {}) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["permits-list"],
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(PERMITS_BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    {
      staleTime: 10 * 60 * 1000, // 10 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
      ...options,
    }
  );
};
